var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFillWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 55",
    d: "M4.9706 2.61358C4.40542 2.76502 3.89005 3.06257 3.47631 3.47631C3.06257 3.89005 2.76502 4.40542 2.61358 4.9706",
    stroke: "#F6F7F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 56",
    d: "M15.0294 2.61358C15.5946 2.76502 16.1099 3.06257 16.5237 3.47631C16.9374 3.89005 17.235 4.40542 17.3864 4.9706",
    stroke: "#F6F7F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.6673C13.6819 16.6673 16.6667 13.6825 16.6667 10.0007C16.6667 6.31875 13.6819 3.33398 10 3.33398C6.31814 3.33398 3.33337 6.31875 3.33337 10.0007C3.33337 13.6825 6.31814 16.6673 10 16.6673ZM11 6.66732C11 6.11503 10.5523 5.66732 10 5.66732C9.44776 5.66732 9.00004 6.11503 9.00004 6.66732V9.75065C9.00004 10.441 9.55969 11.0007 10.25 11.0007H12.5C13.0523 11.0007 13.5 10.5529 13.5 10.0007C13.5 9.44837 13.0523 9.00065 12.5 9.00065H11V6.66732Z",
    fill: "#F6F7F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFillWhite);
export default __webpack_public_path__ + "static/media/Clock_fill_white.c964bfb10c4e7789448614a1854b0c60.svg";
export { ForwardRef as ReactComponent };